import { memo } from 'react'; 
import { IMainContent } from '@/utils/ctype';
import Group from '../Group';
import PartTitle from '../../../components/PartTitle';
import ScrollBody from '../../../components/ScrollBody';
import style from './index.module.less';

const mainContent = memo( function mainContent(props: IMainContent) {
  const {question = [], currentFocus = 0, saveAnswerHandle, answerMap, pageData, loadAnswered, isAI, boxStyle, showDragField, feedback, setShowDragFieldHandle, setFocusIndexHandle, displayAnswerMap} = props;
  const {title, desc} = pageData;
  return (
    <ScrollBody show={showDragField} style={boxStyle} className={style.exercises}>
      <PartTitle title={title||''} desc={desc|| ''}></PartTitle>
      {
        question.map((item, index: number) => <Group displayAnswerMap={displayAnswerMap} data={item} index={index} key={index} 
          currentFocus={currentFocus} saveAnswerHandle={saveAnswerHandle} answerMap={answerMap}
          pageData={pageData} loadAnswered={loadAnswered} isAI={isAI}
          feedbackMap={feedback}
          setShowDragFieldHandle={setShowDragFieldHandle} setFocusIndexHandle={setFocusIndexHandle}></Group>)
      }
    </ScrollBody>
  );
});

export default mainContent;